import { defineStore } from 'pinia'
import Modal from '@/models/modal'

export const useModalStore = defineStore('modal', {
  state: () => ({ modals: undefined }),
  getters: {
  },
  actions: {
    async load() {
      if (!this.modals) {
        this.modals = [
          new Modal(Modal.MODAL_STAGE_REPORT),
          new Modal(Modal.MODAL_STREAK_PROGRESS),
          new Modal(Modal.MODAL_TOOL),
        ]
      }
    },
    get(id) {
      return this.modals.find(m => m.id === id)
    },
    show(id, props) {
      const modal = this.get(id)
      modal.show(props)
    },
    hide(id) {
      const modal = this.get(id)
      modal.hide()
    },
  },
})